import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconSwitch = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <rect
        x="128"
        y="256"
        width="768"
        height="512"
        rx="256"
        ry="256"
        fill={fill}
        opacity="0.3"
      />
      <circle cx="320" cy="512" r="192" fill={fill} />
    </svg>
  )
}

export default IconSwitch